<template>
  <b-modal v-model="show" size="lg" centered header-bg-variant="primary" hide-footer :title="`Verify Registered Member`"  @hide="closeModal()">
    <div>
      <b-row>
        <b-col sm="10">
          <p-input v-model="form.username" label="Username" name="username" :handler="$v" :formData="form" type="text"/>
        </b-col>
        <b-col sm="2">
          <b-form-group>
            <label for="" style="opacity: 0">Search</label>
            <b-button variant="primary" @click="searchMember()">Search</b-button>
          </b-form-group>
        </b-col>
      </b-row>
      <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="item" :fields="fields">
        <template v-slot:cell(sn)="data">
          {{data.index+1}}
        </template>
      </b-table>
    </div>
  </b-modal>
</template>

<script>
import { Events } from '../../../events.js'
import VueNotifications from 'vue-notifications'
import { required, minLength, maxLength } from 'vuelidate/lib/validators'
import { PInput } from '../../../components'
export default {
  name: 'MemberListModal',
  props: {
    showVerifyModal: {
      type: Boolean,
      default: false
    },
    caption: {
      type: String,
      default: 'Table'
    },
    hover: {
      type: Boolean,
      default: false
    },
    striped: {
      type: Boolean,
      default: false
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      fields: [
        {key: 'sn', label: 'S.No'},
        {key: 'Username', label: 'Username'},
        {key: 'PromoCode', label: 'Promo Code'},
        {key: 'AddTime', label: 'Add Time'}
      ],
      item: [],
      form: {
        username: '',
        errorMessages: {
          username: {
            required: 'Please enter username',
            minLength: 'Username must be between 1 to 50 characters',
            maxLength: 'Username must be between 1 to 50 characters'
          }
        }
      }
    }
  },
  validations: {
    form: {
      username: { required, minLength: minLength(1), maxLength: maxLength(50) }
    }
  },
  components: {
    PInput
  },
  computed: {
    show: {
      get: function () {
        return this.showVerifyModal
      },
      set: function () {
        return this.showVerifyModal
      }
    }
  },
  methods: {
    getRowCount (item) {
      return item.length
    },
    async searchMember () {
      this.$v.form.$touch()
      if (this.$v.form.$error) {
        return false
      }
      try {
        let result = await this.$http.post(this.API_ENDPOINT + '/promotion/promoCode/member/register/check', { username: this.form.username }, { header: { 'Content-Type': 'application/json' } })
        this.item = result.data
      } catch (err) {
        let code = err.response.data.code
        let msg = err.response.data.msg
        Events.$emit('alert', VueNotifications.types.error, code, msg)
      }
    },
    closeModal () {
      this.$emit('closeVerifyModal')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/promotion/promoCode/VerifyModal.vue